module.exports = __webpack_public_path__ + "static/img/passo1.9d22492f.svg";